import { WordpressPost } from '@benzinga/content-manager';

export const MockWordpressPost: WordpressPost = {
  blocks: [
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The NBA has recently teamed up with Dapper Labs to create a digital version of NBA trading cards. However, these digital collectibles aren’t cards at all. </p>\n',
      ],
      innerHTML:
        '\n<p>The NBA has recently teamed up with Dapper Labs to create a digital version of NBA trading cards. However, these digital collectibles aren’t cards at all. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Instead they’re collectible in-game highlights from NBA players called Top Shots. NBA Top Shot releases packs of Top Shots on its website every so often, and they sell out quickly. The technology that makes these digital collectibles possible are <a href="https://www.benzinga.com/markets/cryptocurrency/21/02/19780218/nba-top-shot-cryptopunks-and-more-what-you-need-to-know-about-nfts">non-fungible tokens</a>.</p>\n',
      ],
      innerHTML:
        '\n<p>Instead they’re collectible in-game highlights from NBA players called Top Shots. NBA Top Shot releases packs of Top Shots on its website every so often, and they sell out quickly. The technology that makes these digital collectibles possible are <a href="https://www.benzinga.com/markets/cryptocurrency/21/02/19780218/nba-top-shot-cryptopunks-and-more-what-you-need-to-know-about-nfts">non-fungible tokens</a>.</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Unlike most NFTs, Top Shots aren’t ERC-721 tokens, instead these collectibles are NFTs on the Flow Blockchain, a blockchain created by Dapper Labs for NFTs. After Dapper labs clogged the Ethereum network in 2017 with Cryptokitties, they opted to create their own blockchain network for Top Shot. </p>\n',
      ],
      innerHTML:
        '\n<p>Unlike most NFTs, Top Shots aren’t ERC-721 tokens, instead these collectibles are NFTs on the Flow Blockchain, a blockchain created by Dapper Labs for NFTs. After Dapper labs clogged the Ethereum network in 2017 with Cryptokitties, they opted to create their own blockchain network for Top Shot. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Typically, non-fungible tokens use Ethereum’s blockchain to make it impossible to duplicate the collectible. Ethereum tokens used for digital art, concert tickets and collectibles all use the ERC-721 token standard for Ethereum tokens. What makes ERC-721 tokens special is that they’re non-fungible, meaning that each token is capable of holding a distinct value. </p>\n',
      ],
      innerHTML:
        '\n<p>Typically, non-fungible tokens use Ethereum’s blockchain to make it impossible to duplicate the collectible. Ethereum tokens used for digital art, concert tickets and collectibles all use the ERC-721 token standard for Ethereum tokens. What makes ERC-721 tokens special is that they’re non-fungible, meaning that each token is capable of holding a distinct value. </p>\n',
    },
    {
      attrs: {
        data: {
          _cta_placeholder_type: 'cta_placeholder_type',
          _default_cta: 'default_cta',
          cta_placeholder_type: 'primary',
          default_cta: '',
        },
        id: 'block_6053b3cdf7394',
        mode: 'edit',
        name: 'acf/cta-placeholder',
      },
      blockName: 'acf/cta-placeholder',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: {
        ordered: false,
      },
      blockName: 'advanced-gutenberg-blocks/summary',
      headers: [
        {
          html: 'NBA Top Shots NFTs',
          id: 'n-b-a-top-shots-n-f-ts',
          level: '2',
          text: 'NBA Top Shots NFTs',
        },
        {
          html: 'How to Buy NBA Top Shots NFT',
          id: 'how-to-buy-n-b-a-top-shots-n-f-t',
          level: '2',
          text: 'How to Buy NBA Top Shots NFT',
        },
        {
          html: 'Best Crypto Wallets',
          id: 'best-crypto-wallets',
          level: '2',
          text: 'Best Crypto Wallets',
        },
        {
          html: 'Best Cryptocurrency Exchange Platforms',
          id: 'best-cryptocurrency-exchange-platforms',
          level: '2',
          text: 'Best Cryptocurrency Exchange Platforms',
        },
        {
          html: 'Current Crypto Prices',
          id: 'current-crypto-prices',
          level: '2',
          text: 'Current Crypto Prices',
        },
        {
          html: 'NBA Top Shots or Traditional Cards?',
          id: 'n-b-a-top-shots-or-traditional-cards',
          level: '2',
          text: 'NBA Top Shots or Traditional Cards?',
        },
        {
          html: 'Frequently Asked Questions',
          id: 'frequently-asked-questions',
          level: '2',
          text: 'Frequently Asked Questions',
        },
      ],
      innerBlocks: [],
      innerContent: [
        '\n<div class="wp-block-advanced-gutenberg-blocks-summary"><p class="wp-block-advanced-gutenberg-blocks-summary__title">Contents</p><div class="wp-block-advanced-gutenberg-blocks-summary__fold"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></div><ul role="directory" class="wp-block-advanced-gutenberg-blocks-summary__list"><li><a href="#nba-top-shots-nfts">NBA Top Shots NFTs</a><ul></ul></li><li><a href="#how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</a><ul></ul></li><li><a href="#best-crypto-wallets">Best Crypto Wallets</a><ul><li><a href="#best-software-wallet-dapper">Best Software Wallet: Dapper</a><ul></ul></li><li><a href="#best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</a><ul></ul></li></ul></li><li><a href="#best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</a><ul></ul></li><li><a href="#current-crypto-prices">Current Crypto Prices</a><ul></ul></li><li><a href="#nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</a><ul></ul></li><li><a href="#frequently-asked-questions">Frequently Asked Questions</a><ul></ul></li></ul></div>\n',
      ],
      innerHTML:
        '\n<div class="wp-block-advanced-gutenberg-blocks-summary"><p class="wp-block-advanced-gutenberg-blocks-summary__title">Contents</p><div class="wp-block-advanced-gutenberg-blocks-summary__fold"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewbox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-up"><polyline points="18 15 12 9 6 15"></polyline></svg></div><ul role="directory" class="wp-block-advanced-gutenberg-blocks-summary__list"><li><a href="#nba-top-shots-nfts">NBA Top Shots NFTs</a><ul></ul></li><li><a href="#how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</a><ul></ul></li><li><a href="#best-crypto-wallets">Best Crypto Wallets</a><ul><li><a href="#best-software-wallet-dapper">Best Software Wallet: Dapper</a><ul></ul></li><li><a href="#best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</a><ul></ul></li></ul></li><li><a href="#best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</a><ul></ul></li><li><a href="#current-crypto-prices">Current Crypto Prices</a><ul></ul></li><li><a href="#nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</a><ul></ul></li><li><a href="#frequently-asked-questions">Frequently Asked Questions</a><ul></ul></li></ul></div>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="nba-top-shots-nfts">NBA Top Shots NFTs</h2>\n'],
      innerHTML: '\n<h2 id="nba-top-shots-nfts">NBA Top Shots NFTs</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The NBA Top Shots are digital collectibles that may be the next evolution of trading cards. However, these collectibles hardly resemble a physical NBA trading card. Top Shots main feature is player highlight video clips.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>The NBA Top Shots are digital collectibles that may be the next evolution of trading cards. However, these collectibles hardly resemble a physical NBA trading card. Top Shots main feature is player highlight video clips.&nbsp;</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>For example, the Lebron James Dunk Top Shot features Lebron James dunking on the Houston Rockets. This Top Shot is particularly sought after and extremely limited –– the highest sold edition sold for north of $200,000. Other Top Shots are as cheap as $5, and you can view the transaction history for each collectible to get an idea of how its value has changed over time.</p>\n',
      ],
      innerHTML:
        '\n<p>For example, the Lebron James Dunk Top Shot features Lebron James dunking on the Houston Rockets. This Top Shot is particularly sought after and extremely limited –– the highest sold edition sold for north of $200,000. Other Top Shots are as cheap as $5, and you can view the transaction history for each collectible to get an idea of how its value has changed over time.</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</h2>\n'],
      innerHTML: '\n<h2 id="how-to-buy-nba-top-shots-nft">How to Buy NBA Top Shots NFT</h2>\n',
    },
    {
      attrs: {
        defaultDurationText: 'Time needed:',
        steps: [
          {
            id: 'how-to-step-1621024341417',
            jsonName: 'Make an NBA Top Shot account. ',
            jsonText:
              'To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.<br/><br/>Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. ',
            name: ['Make an NBA Top Shot account. '],
            text: [
              'To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.',
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              'Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. ',
            ],
          },
          {
            id: 'how-to-step-1621024360584',
            jsonName: 'Buy a wallet (optional).',
            jsonText:
              'If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.',
            name: ['Buy a wallet (optional).'],
            text: [
              'If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.',
            ],
          },
          {
            id: 'how-to-step-1621024385027',
            jsonName: 'Buy a piece from the collection.',
            jsonText:
              'You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.<br/><br/>NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.<br/><br/>If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.',
            name: ['Buy a piece from the collection.'],
            text: [
              'You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.',
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              'NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.',
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              {
                props: {
                  children: [],
                },
                type: 'br',
              },
              'If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.',
            ],
          },
        ],
      },
      blockName: 'yoast/how-to-block',
      innerBlocks: [],
      innerContent: [
        '\n<div class="schema-how-to wp-block-yoast-how-to-block"><p class="schema-how-to-description"></p> <ol class="schema-how-to-steps"><li class="schema-how-to-step" id="how-to-step-1621024341417"><strong class="schema-how-to-step-name">Make an NBA Top Shot account. </strong> <p class="schema-how-to-step-text">To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.<br/><br/>Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. </p> </li><li class="schema-how-to-step" id="how-to-step-1621024360584"><strong class="schema-how-to-step-name">Buy a wallet (optional).</strong> <p class="schema-how-to-step-text">If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.</p> </li><li class="schema-how-to-step" id="how-to-step-1621024385027"><strong class="schema-how-to-step-name">Buy a piece from the collection.</strong> <p class="schema-how-to-step-text">You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.<br/><br/>NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.<br/><br/>If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.</p> </li></ol></div>\n',
      ],
      innerHTML:
        '\n<div class="schema-how-to wp-block-yoast-how-to-block"><p class="schema-how-to-description"></p> <ol class="schema-how-to-steps"><li class="schema-how-to-step" id="how-to-step-1621024341417"><strong class="schema-how-to-step-name">Make an NBA Top Shot account. </strong> <p class="schema-how-to-step-text">To make an NBA Top Shot account, visit nbatopshop.com and click sign up. You can sign up with an email or by connecting your google account to the website.<br/><br/>Next you’ll be prompted to copy a one-time code you can use to recover your account –– make sure to save this somewhere safe in case you ever need it. After this, you’ll be greeted with some videos explaining what NBA Top Shots are and how to go about purchasing them. </p> </li><li class="schema-how-to-step" id="how-to-step-1621024360584"><strong class="schema-how-to-step-name">Buy a wallet (optional).</strong> <p class="schema-how-to-step-text">If you plan on holding your NBA Top Shots NFTs for the long term, you should transfer your collectibles to your Dapper Wallet. Dapper makes a special wallet to use for the Flow Blockchain, and you can download it from Dapper’s website. Cryptocurrency wallets are a much safer way to store your crypto assets; leaving your NFTs or cryptocurrency on an exchange puts your assets at risk of being hacked. Since these NFTs are on the Flow blockchain, you can’t store your Top Shots on an Ethereum wallet like other NFTs.</p> </li><li class="schema-how-to-step" id="how-to-step-1621024385027"><strong class="schema-how-to-step-name">Buy a piece from the collection.</strong> <p class="schema-how-to-step-text">You can either buy singular Top Shots on the secondary marketplace or purchase card packs from NBA Top Shots directly. Currently, all card packs are sold out and often sell out extremely quickly after the release.<br/><br/>NBA Top Shot has 2 types of card packs: a base set and a Rising Stars pack. The base set sells for $9, while the Rising Stars pack retails for $199 and gives you a much better chance at a rare collectible.<br/><br/>If you’re unable to buy a pack of Top Shots when they’re released, then you’ll need to buy the collectibles on the secondary marketplace. Purchasing from the secondary marketplace also lets you choose which card you want to buy.</p> </li></ol></div>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="best-crypto-wallets">Best Crypto Wallets</h2>\n'],
      innerHTML: '\n<h2 id="best-crypto-wallets">Best Crypto Wallets</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: ['\n<p>Here are the best software and hardware wallets to store your NBA Top Shot NFTs.</p>\n'],
      innerHTML: '\n<p>Here are the best software and hardware wallets to store your NBA Top Shot NFTs.</p>\n',
    },
    {
      attrs: {
        level: 3,
      },
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h3 id="best-software-wallet-dapper">Best Software Wallet: Dapper</h3>\n'],
      innerHTML: '\n<h3 id="best-software-wallet-dapper">Best Software Wallet: Dapper</h3>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Dapper has its own unique software wallet you can store your NFTs on securely. The application is free to use, and you can create a new software wallet in just a few minutes. Since this software wallet works specifically for the Flow blockchain, you can’t store Ethereum-based NFTs in this wallet. If you try to send other types of NFTs to your Dapper wallet, your collectibles will be lost in the blockchain transaction.</p>\n',
      ],
      innerHTML:
        '\n<p>Dapper has its own unique software wallet you can store your NFTs on securely. The application is free to use, and you can create a new software wallet in just a few minutes. Since this software wallet works specifically for the Flow blockchain, you can’t store Ethereum-based NFTs in this wallet. If you try to send other types of NFTs to your Dapper wallet, your collectibles will be lost in the blockchain transaction.</p>\n',
    },
    {
      attrs: {
        align: 'right',
        data: {
          _cta_button_text: 'field_5cb4979c88b63',
          _hide_attributes: 'hide_attributes',
          _layout: 'field_5cbf2ec8e9b44',
          _placement_identifier: 'placement_identifier',
          _product: 'field_5978cdb7f1280',
          _product_link_type: 'field_5cb4bc4c7821f',
          _show_best_for: 'field_5c7d671aacc4e',
          _show_commissions: 'field_5c7d66f8acc4d',
          _show_company_name: 'field_5cb4bb4064ecd',
          _show_cons: 'field_5c7d6744acc50',
          _show_pros: 'field_5c7d6731acc4f',
          _show_star_rating: 'field_5cb4bd781b5f6',
          cta_button_text: '',
          hide_attributes: '0',
          layout: 'auto',
          placement_identifier: {
            placement_id: 23219,
          },
          product: 99401,
          product_link_type: 'default',
          show_best_for: '0',
          show_commissions: '0',
          show_company_name: '0',
          show_cons: '0',
          show_pros: '0',
          show_star_rating: '1',
        },
        id: 'block_6053b3d9f7395',
        mode: 'preview',
        name: 'acf/product-review-card',
      },
      blockName: 'acf/product-review-card',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
      product: {
        best_for: 'ERC-20 tokens',
        details: {
          best_for: ['ERC-20 tokens', 'All experience levels'],
          cons: ['Can be quite pricey'],
          desc: '<p><span style="font-weight: 400;">Launched in 2014, Ledger has transformed into a fast-paced, growing company developing infrastructure and security solutions for cryptocurrencies as well as blockchain applications for companies and individuals. Born in Paris, the company has since expanded to more than 130 employees in France and San Francisco.</span></p>\n<p><span style="font-weight: 400;">With 1,500,000 Ledger wallets already sold in 165 countries, the company aims at securing the new disruptive class of crypto assets. Ledger has developed a distinctive operating system called BOLOS, which it integrates to a secure chip for its line of wallets. So far, Ledger takes pride in being the only market player to provide this technology.</span></p>\n',
          pros: [
            'Easy to set up and use',
            'Supports more than 1,500 different digital assets',
            'Tamper proof',
            'Portable',
            'Long-lasting battery',
            'Bluetooth connectivity features',
          ],
        },
        id: 99401,
        image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/02/12104446/ledger.png',
        link: 'https://www.benzinga.com/go/ledger-hardware-wallet',
        name: 'Ledger Hardware Wallet',
        rating: 5,
        review: 'https://www.benzinga.com/money/ledger-wallet-review/',
      },
    },
    {
      attrs: {
        level: 3,
      },
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h3 id="best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</h3>\n'],
      innerHTML: '\n<h3 id="best-hardware-wallet-ledger-nano-s">Best Hardware Wallet: Ledger Nano S</h3>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The safest way to store your NFTs and cryptocurrency is with a hardware wallet. Hardware wallets are physical devices that store your cryptocurrency offline, making it impossible for your assets to be stolen by online hackers.</p>\n',
      ],
      innerHTML:
        '\n<p>The safest way to store your NFTs and cryptocurrency is with a hardware wallet. Hardware wallets are physical devices that store your cryptocurrency offline, making it impossible for your assets to be stolen by online hackers.</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Ledger is one of the most well known hardware wallet producers on the market. They offer a few products, most notably the Ledger Nano S and the Ledger Nano X. Both these hardware wallets serve the same function, but the Nano X is Ledger’s more premium wallet. </p>\n',
      ],
      innerHTML:
        '\n<p>Ledger is one of the most well known hardware wallet producers on the market. They offer a few products, most notably the Ledger Nano S and the Ledger Nano X. Both these hardware wallets serve the same function, but the Nano X is Ledger’s more premium wallet. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>The Ledger Nano S comes in at an affordable price for most crypto investors, coming in at just over $50. If you opt for the Ledger Nano X, expect to pay north of $100.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>The Ledger Nano S comes in at an affordable price for most crypto investors, coming in at just over $50. If you opt for the Ledger Nano X, expect to pay north of $100.&nbsp;</p>\n',
    },
    {
      attrs: {
        height: 20,
      },
      blockName: 'core/spacer',
      innerBlocks: [],
      innerContent: ['\n<div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>\n'],
      innerHTML: '\n<div style="height:20px" aria-hidden="true" class="wp-block-spacer"></div>\n',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</h2>\n'],
      innerHTML: '\n<h2 id="best-cryptocurrency-exchange-platforms">Best Cryptocurrency Exchange Platforms</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Cryptocurrency exchanges let you purchase crypto using your bank account. In order to buy Ethereum, Bitcoin or Bitcoin Cash, you’ll need to use a cryptocurrency exchange. Alternatively, if you know someone who owns cryptocurrency, you could buy it directly from them and have the seller send the crypto to your cryptocurrency wallet.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>Cryptocurrency exchanges let you purchase crypto using your bank account. In order to buy Ethereum, Bitcoin or Bitcoin Cash, you’ll need to use a cryptocurrency exchange. Alternatively, if you know someone who owns cryptocurrency, you could buy it directly from them and have the seller send the crypto to your cryptocurrency wallet.&nbsp;</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Some popular exchanges that make it easy to buy and sell cryptocurrency are Gemini, Coinbase and eToro. </p>\n',
      ],
      innerHTML:
        '\n<p>Some popular exchanges that make it easy to buy and sell cryptocurrency are Gemini, Coinbase and eToro. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Coinbase is especially secure. It stores 98% of investors funds in a hardware wallet, leaving the other 2% on the exchange for liquidity. These exchanges all have easy to use interfaces and support all 3 of the cryptocurrencies that NBA Top Shots accepts.</p>\n',
      ],
      innerHTML:
        '\n<p>Coinbase is especially secure. It stores 98% of investors funds in a hardware wallet, leaving the other 2% on the exchange for liquidity. These exchanges all have easy to use interfaces and support all 3 of the cryptocurrencies that NBA Top Shots accepts.</p>\n',
    },
    {
      attrs: {
        data: {
          _cta_placeholder_type: 'cta_placeholder_type',
          _default_cta: 'default_cta',
          cta_placeholder_type: 'compare-products-placement',
          default_cta: '',
        },
        id: 'block_6053b403f7396',
        mode: 'edit',
        name: 'acf/cta-placeholder',
      },
      blockName: 'acf/cta-placeholder',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="current-crypto-prices">Current Crypto Prices</h2>\n'],
      innerHTML: '\n<h2 id="current-crypto-prices">Current Crypto Prices</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Non-fungible tokens have gained popularity alongside the current cryptocurrency bull market. The entire cryptocurrency market cap has appreciated hundreds of billions of dollars this year alone. </p>\n',
      ],
      innerHTML:
        '\n<p>Non-fungible tokens have gained popularity alongside the current cryptocurrency bull market. The entire cryptocurrency market cap has appreciated hundreds of billions of dollars this year alone. </p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Typically, large market capitalization cryptos are less volatile than small market cap coins and are regarded as a less risky investment. To get an idea of the cryptocurrency market sentiment, you can monitor how the price of large cryptocurrencies like Bitcoin and Ethereum are moving.</p>\n',
      ],
      innerHTML:
        '\n<p>Typically, large market capitalization cryptos are less volatile than small market cap coins and are regarded as a less risky investment. To get an idea of the cryptocurrency market sentiment, you can monitor how the price of large cryptocurrencies like Bitcoin and Ethereum are moving.</p>\n',
    },
    {
      attrs: {
        data: {
          _coins_number: 'field_coins_number',
          _go_link: 'field_5bbcdcb094037',
          coins_number: '',
          go_link: '',
        },
        id: 'block_6053b41af7397',
        mode: 'preview',
        name: 'acf/cryptocurrencies',
      },
      blockName: 'acf/cryptocurrencies',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</h2>\n'],
      innerHTML: '\n<h2 id="nba-top-shots-or-traditional-cards">NBA Top Shots or Traditional Cards?</h2>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>Since NBA Top Shots are digital collectibles, they can offer more than traditional trading cards. These collectibles are cube shaped, and each face of the cube has different features. The collectibles feature in-game clips of different basketball players, as well as game records and a picture of the player featured on the card.&nbsp;</p>\n',
      ],
      innerHTML:
        '\n<p>Since NBA Top Shots are digital collectibles, they can offer more than traditional trading cards. These collectibles are cube shaped, and each face of the cube has different features. The collectibles feature in-game clips of different basketball players, as well as game records and a picture of the player featured on the card.&nbsp;</p>\n',
    },
    {
      attrs: [],
      blockName: 'core/paragraph',
      innerBlocks: [],
      innerContent: [
        '\n<p>If NBA Top Shots replace NBA playing cards in the future, the initial releases will likely be worth a lot of money someday, like rare trading cards from the 1950s. </p>\n',
      ],
      innerHTML:
        '\n<p>If NBA Top Shots replace NBA playing cards in the future, the initial releases will likely be worth a lot of money someday, like rare trading cards from the 1950s. </p>\n',
    },
    {
      attrs: {
        data: {
          _cta_placeholder_type: 'cta_placeholder_type',
          _default_cta: 'default_cta',
          cta_placeholder_type: 'secondary',
          default_cta: '',
        },
        id: 'block_6053b422f7398',
        mode: 'edit',
        name: 'acf/cta-placeholder',
      },
      blockName: 'acf/cta-placeholder',
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
    {
      attrs: [],
      blockName: 'core/heading',
      innerBlocks: [],
      innerContent: ['\n<h2 id="frequently-asked-questions">Frequently Asked Questions</h2>\n'],
      innerHTML: '\n<h2 id="frequently-asked-questions">Frequently Asked Questions</h2>\n',
    },
    {
      attrs: {
        data: {
          _questions: 'faq',
          _questions_0_answer: 'faq_answer',
          _questions_0_question: 'faq_question',
          _questions_1_answer: 'faq_answer',
          _questions_1_question: 'faq_question',
          _style_faq: 'field_style_faq',
          questions: 2,
          questions_0_answer:
            '<span style="font-weight: 400;">NBA Top Shot started in October 2020. Since its inception, the company has transacted over $230 million of Top Shots on its website. The company is a joint venture between the NBA and Dapper Labs, the developer of the popular crypto game, CryptoKitties. </span>',
          questions_0_question: 'Q. When did NBA Top Shot start?\r\n',
          questions_1_answer:
            '<span style="font-weight: 400;">Top Shot is a platform where you can buy and sell digital basketball collectibles. It’s powered by the Flow Blockchain made by Dapper Labs, and it uses non-fungible tokens to authenticate its digital collectibles. If a token is non fungible, then each token can hold a distinct value, allowing for collectibles like trading cards to be tokenized on the blockchain.</span>',
          questions_1_question: 'Q. How does Top Shot work?\r\n',
          style_faq: 'default',
        },
        id: 'block_6053b564f7399',
        mode: 'edit',
        name: 'acf/faq',
      },
      blockName: 'acf/faq',
      faq: [
        {
          answer:
            '<span style="font-weight: 400;">NBA Top Shot started in October 2020. Since its inception, the company has transacted over $230 million of Top Shots on its website. The company is a joint venture between the NBA and Dapper Labs, the developer of the popular crypto game, CryptoKitties. </span>',
          question: 'Q. When did NBA Top Shot start?\r\n',
        },
        {
          answer:
            '<span style="font-weight: 400;">Top Shot is a platform where you can buy and sell digital basketball collectibles. It’s powered by the Flow Blockchain made by Dapper Labs, and it uses non-fungible tokens to authenticate its digital collectibles. If a token is non fungible, then each token can hold a distinct value, allowing for collectibles like trading cards to be tokenized on the blockchain.</span>',
          question: 'Q. How does Top Shot work?\r\n',
        },
      ],
      innerBlocks: [],
      innerContent: [],
      innerHTML: '',
    },
  ],
  campaigns: {
    compare_partners: {
      blocks: [
        {
          attrs: {
            data: {
              _compare_products: 'block_compare_products',
              _default_open_description: 'default_open_description',
              _show_product_names: 'show_product_names',
              compare_products: ['125386', '154299', '24544', '128031', '93843', '61546'],
              default_open_description: '0',
              show_product_names: '0',
            },
            id: 'block_5ec57711e2d32',
            mode: 'edit',
            name: 'acf/compare-products',
          },
          blockName: 'acf/compare-products',
          innerBlocks: [],
          innerContent: [],
          innerHTML: '',
          products: [
            {
              best_for: 'Low Minimums',
              details: {
                best_for: ['Active traders', 'Intermediate traders'],
                cons: ['Only offers 14 coins'],
                desc: '<p>Webull, founded in 2017, is a mobile app-based brokerage that features commission-free stock and exchange-traded fund (ETF) trading. It’s regulated by the Securities and Exchange Commission (SEC) and the Financial Industry Regulatory Authority (FINRA).</p>\n<p>Webull offers active traders technical indicators, economic calendars, ratings from research agencies, margin trading and short-selling. Webull’s trading platform is designed for intermediate and experienced traders, although beginning traders can also benefit.</p>\n<p>Webull is widely considered one of the best Robinhood alternatives.</p>\n',
                pros: [
                  'No charges to open and maintain an account',
                  'No account maintenance fees or software platform fees',
                  'Intuitive trading platform with technical and fundamental analysis tools',
                ],
              },
              id: 125386,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/20154335/Webull.png',
              link: 'https://www.benzinga.com/go/webull-crypto',
              name: 'Webull Crypto',
              rating: 4,
              review: 'https://www.benzinga.com/money/webull-review/',
            },
            {
              best_for: 'Staking Crypto + Earning Rewards',
              details: {
                best_for: ['Newcomers to the cryptocurrency world', 'Ease of use', 'Trezor integration'],
                cons: ['FTX app not available on the mobile app'],
                desc: '<p><span style="font-weight: 400;">Founded in 2015, </span><b>Exodus</b><span style="font-weight: 400;"> is a multiasset software wallet that removes the geek requirement and keeps design a priority to make </span><a href="https://www.benzinga.com/money/best-cryptocurrency/"><span style="font-weight: 400;">cryptocurrency</span></a><span style="font-weight: 400;"> and digital assets easy for everyone. Available for desktop and mobile, Exodus allows users to secure, manage and exchange cryptocurrencies like </span><a href="https://www.benzinga.com/money/is-bitcoin-a-good-investment/"><span style="font-weight: 400;">Bitcoin</span></a><span style="font-weight: 400;"> (BTC), </span><a href="https://www.benzinga.com/money/is-ethereum-a-good-investment/"><span style="font-weight: 400;">Ethereum</span></a><span style="font-weight: 400;"> (ETH) and more across an industry-leading 10,000-plus asset pairs from a beautiful, easy-to-use wallet. The noncustodial functionality is encrypted locally on users’ own devices, ensuring privacy, security and complete control over their wealth. Exodus is on a mission to empower half the world to exit the traditional finance system by 2030.</span></p>\n',
                pros: [
                  'Free',
                  'Huge selection of cryptocurrencies',
                  'Excellent 24/7 customer support',
                  'No personal info needed',
                ],
              },
              id: 154299,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21155553/Exodus_logo_dark.png',
              link: 'https://www.benzinga.com/go/exodus-wallet',
              name: 'Exodus Wallet',
              rating: 4,
              review: 'https://www.benzinga.com/money/exodus-bitcoin-crypto-wallet-review/',
            },
            {
              best_for: 'Copy Trading',
              details: {
                best_for: [
                  'U.S. based cryptocurrency traders',
                  'Investors looking to CopyTrade other traders',
                  'Simple user interface',
                ],
                cons: ['Only 29 coins available'],
                desc: '<p>eToro, headquartered in Cyprus, England and Israel, has provided forex products and other CFD derivatives to retail clients since 2007. A major eToro plus is its social trading operations, including OpenBook, which allows new clients to copy trade the platform’s best performers. Its social trading features are top notch, but eToro loses points for its lack of tradable currency pairs and underwhelming research and customer service features</p>\n',
                pros: [
                  'Several major cryptocurrencies and altcoins',
                  'Expansive network of social trading features',
                  'Large client base for new traders to imitate',
                ],
              },
              id: 24544,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/19155902/etoro-e1589918475382.png',
              link: 'https://www.benzinga.com/go/etoro',
              name: 'eToro',
              rating: 4,
              review: 'https://www.benzinga.com/money/etoro-review/',
            },
            {
              best_for: 'A Fast Trading Experience',
              details: {
                best_for: [],
                cons: [],
                desc: '',
                pros: [],
              },
              id: 128031,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
              link: 'https://www.benzinga.com/go/uphold-crypto-convertor',
              name: 'Uphold Crypto',
              rating: 4,
              review: 'https://www.benzinga.com/money/uphold-review/',
            },
            {
              best_for: 'New Investors',
              details: {
                best_for: [
                  'New investors looking for a simple mobile and web app',
                  'Day traders looking to use technical analysis tools',
                  'Users looking for a 1-stop-shop to buy, sell and store all of their cryptos',
                ],
                cons: [
                  'Charges both a commission and a convenience fee for users buying and selling through the desktop or mobile app',
                ],
                desc: '<p>Gemini is a cryptocurrency exchange and custodian that offers investors access to over 100 coins and tokens. Founded in the US, Gemini is expanding globally, in particular into Europe and Asia. Offerings include both major cryptocurrency projects like Bitcoin and Ethereum, and smaller altcoins like Orchid and 0x.</p>\n<p><span style="font-weight: 400;">Gemini is 1 of the only brokers with multiple platform options based on skill level. New investors will love the streamlined interface of Gemini’s mobile and web apps, while advanced investors might appreciate all the tools that come with ActiveTrader. </span></p>\n<p><span style="font-weight: 400;">In addition to a host of platform choices, Gemini users also have access to insured hot wallets to store tokens without worrying about digital asset theft. Learn more about what Gemini can do for you in our review.</span></p>\n',
                pros: [
                  'Easy and quick signups — can get started in as little as a 5 minutes',
                  'Multitude of platforms to accommodate traders of all skill levels',
                  'Hot wallets include insurance to protect your from theft and hacking attempts',
                ],
              },
              id: 93843,
              image: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/11153952/gemini-large.png',
              link: 'https://www.benzinga.com/go/gemini-crypto',
              name: 'Gemini Crypto',
              rating: 4,
              review: 'https://www.benzinga.com/money/gemini-review/',
            },
            {
              best_for: 'Coinbase Learn',
              details: {
                best_for: [
                  'New cryptocurrency traders',
                  'Cryptocurrency traders interested in major pairs',
                  'Cryptocurrency traders interested in a simple platform',
                ],
                cons: ['Higher fees than competitors'],
                desc: '<p><span style="font-weight: 400;">Coinbase is one of the Internet’s largest cryptocurrency trading platforms. From Bitcoin to Litecoin or Basic Attention Token to Chainlink, Coinbase makes it exceptionally simple to buy and sell major cryptocurrency pairs. </span></p>\n<p><span style="font-weight: 400;">You can even earn cryptocurrency rewards through Coinbase’s unique Coinbase Earn feature. More advanced traders will love the Coinbase Pro platform, which offers more order types and enhanced functionality.</span></p>\n<p><span style="font-weight: 400;">Though Coinbase doesn’t offer the most affordable pricing or the lowest fees, its simple platform is easy enough for complete beginners to master in as little as a single trade. </span></p>\n',
                pros: [
                  'Simple platform is easy to operate',
                  'Comprehensive mobile app mirrors desktop functionality',
                  'Coinbase Earn feature rewards you with crypto for learning about available coins',
                ],
              },
              id: 61546,
              image:
                'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/10/02202252/coinbase-new-2021-logo-FA5145228F-seeklogo.com_.png',
              link: 'https://www.benzinga.com/go/coinbase',
              name: 'Coinbase',
              rating: 4,
              review: 'https://www.benzinga.com/money/coinbase-review/',
            },
          ],
        },
        {
          attrs: [],
          blockName: 'core/paragraph',
          innerBlocks: [],
          innerContent: ['\n<p></p>\n'],
          innerHTML: '\n<p></p>\n',
        },
      ],
      widget: {
        ID: 69884,
        comment_count: '0',
        comment_status: 'closed',
        filter: 'raw',
        guid: 'https://www.benzinga.com/?post_type=widget&#038;p=69884',
        menu_order: 0,
        ping_status: 'closed',
        pinged: '',
        post_author: '60',
        post_content:
          '<!-- wp:acf/compare-products {\n    "id": "block_5ec57711e2d32",\n    "name": "acf\\/compare-products",\n    "data": {\n        "compare_products": [\n            "125386",\n            "154299",\n            "24544",\n            "128031",\n            "93843",\n            "61546"\n        ],\n        "_compare_products": "block_compare_products",\n        "show_product_names": "0",\n        "_show_product_names": "show_product_names",\n        "default_open_description": "0",\n        "_default_open_description": "default_open_description"\n    },\n    "mode": "edit"\n} /-->\n\n<!-- wp:paragraph -->\n<p></p>\n<!-- /wp:paragraph -->',
        post_content_filtered: '',
        post_date: '2020-05-20 14:32:46',
        post_date_gmt: '2020-05-20 18:32:46',
        post_excerpt: '',
        post_mime_type: '',
        post_modified: '2022-03-01 17:07:28',
        post_modified_gmt: '2022-03-01 22:07:28',
        post_name: 'compare-brokers-cryptocurrency',
        post_parent: 0,
        post_password: '',
        post_status: 'publish',
        post_title: 'Compare Brokers - Cryptocurrency',
        post_type: 'widget',
        to_ping: '',
      },
    },
    floating: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      display_y_position: 400,
      has_targeting: true,
      placements: [
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description:
              'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
            cta_text: 'claim now',
            cta_title: 'Benzinga x Wealthsimple',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure: '',
            href: 'https://www.benzinga.com/go/wealthsimple-crypto',
            image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'Wealthsimple',
            placement_slug: 'wealthsimple-crypto',
            product_id: null,
            url: 'https://www.benzinga.com/go/wealthsimple-crypto',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
          },
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
    popup: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      delay: 10000,
      has_targeting: true,
      placements: [
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
            cta_text: 'Claim Now',
            cta_title: 'Earn 12.3% APY on Crypto! ',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure:
              'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
            href: 'https://www.benzinga.com/go/hodlnaut',
            image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'Hodlnaut',
            placement_slug: 'hodlnaut',
            product_id: null,
            url: 'https://www.benzinga.com/go/hodlnaut',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
          },
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
    primary: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      has_targeting: true,
      placeholder_type: 'primary',
      placements: [
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description:
              'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
            cta_text: 'Get Started',
            cta_title: 'Get $100,000 to practice your trading skills',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure:
              'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
            href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
            image_url:
              'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'eToro',
            placement_slug: 'etoro-crypto-non-us',
            product_id: null,
            url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
          },
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
    secondary: {
      campaigns: {
        '145338': {
          cta_btn_position: 'below_content',
          cta_btn_type: 'button',
          cta_description: 'By completing one crypto trade! Choose from SHIB, DOGE, BTC, ADA or ETH.',
          cta_text: 'Claim Now',
          cta_title: 'NOW - March 31th Get $5 in Crypto',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'This promotion offer is open only to eligible customers. Please refer to the Terms and Conditions for eligibility.',
          href: 'https://www.benzinga.com/go/webull-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/05/04175911/Blue_Webull-1.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'webull-crypto-september-2021',
          product_id: null,
          url: 'https://www.benzinga.com/go/webull-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Webull Crypto March` ::Title:: `NOW - March 31th Get $5 in Crypto`',
        },
        '146667': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            "Seamlessly access crypto markets through IBKR's professional-grade desktop platform and intuitive mobile and web platforms. ",
          cta_text: 'get started',
          cta_title: 'NEW! Trade Crypto on Interactive Brokers',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ibkr-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2019/02/21143009/interactive.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IBKR',
          placement_slug: 'ibkr-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ibkr-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IBKR Crypto` ::Partner:: `IBKR` ::Title:: `NEW! Trade Crypto on Interactive Brokers`',
        },
        '151842': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Get a $50 cash bonus and commission-free trades when you open a Wealthsimple Crypto account and deposit and trade at least $150. ',
          cta_text: 'claim now',
          cta_title: 'Benzinga x Wealthsimple',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/wealthsimple-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/08/20152330/Wealthsimple_logo-1.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Wealthsimple',
          placement_slug: 'wealthsimple-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/wealthsimple-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Wealthsimple Crypto` ::Partner:: `Wealthsimple` ::Title:: `Benzinga x Wealthsimple`',
        },
        '168774': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'Sign up with Hodlnaut now and get $20 FREE in crypto.',
          cta_text: 'Claim Now',
          cta_title: 'Earn 12.3% APY on Crypto! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'Deposit US$1000 worth of supported crypto assets in a single transaction as your first deposit or within one week of your first deposit and get a US$20 bonus in kind!',
          href: 'https://www.benzinga.com/go/hodlnaut',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/01/03162233/hodlnaut.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Hodlnaut',
          placement_slug: 'hodlnaut',
          product_id: null,
          url: 'https://www.benzinga.com/go/hodlnaut',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Hodlnaut` ::Partner:: `Hodlnaut` ::Title:: `Earn 12.3% APY on Crypto!`',
        },
        '170835': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Forget about trading pairs: with one click you can trade from one coin to another, without having to trade to another currency first.',
          cta_text: 'Get Started',
          cta_title: 'Deposit 100 CAD and get 20 CAD in BTC! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/coinsmart',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2022/02/22080710/coinsmart.png',
          impression_tag: '',
          link_type: 'internal',
          placement_slug: 'coinsmart',
          product_id: null,
          url: 'https://www.benzinga.com/go/coinsmart',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `CoinSmart` ::Title:: `Deposit 100 CAD and get 20 CAD in BTC!`',
        },
        '170985': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description: 'On IFC Markets! Plus, get a 50% bonus. ',
          cta_text: 'get started',
          cta_title: 'Trade Crypto CFDs! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/ifc-markets-crypto',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/09/17110250/ifc-markets.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'IFC Markets',
          placement_slug: 'ifc-markets-crypto',
          product_id: null,
          url: 'https://www.benzinga.com/go/ifc-markets-crypto',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `IFC Markets Crypto` ::Partner:: `IFC Markets` ::Title:: `Trade Crypto CFDs!`',
        },
        '172279': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
          cta_text: 'Get Started',
          cta_title: 'Earn Crypto Rewards',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/exodus-wallet',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Exodus Wallet',
          placement_slug: 'exodus',
          product_id: null,
          url: 'https://www.benzinga.com/go/exodus-wallet',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
        },
        '68921': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Buy $100 worth of crypto and get a $10 bonus! Build a diversified portfolio with Bitcoin, Ethereum, and other popular coins — or simply copy eToro’s top crypto traders!',
          cta_text: 'claim now',
          cta_title: 'Limited Time Offer: Trade $100, Get $10',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro supports the following currencies: BTC, ADA, DASH, DOGE, EOS, ETH, LTC, NEO, XLM, XTZ, TRX, ZEC. eToro USA LLC; Investments are subject to market risk, including the possible loss of principal. T&Cs apply. *The bonus is available to Benzinga readers in the US for open states only. Served by eToro USA LLC.\r\n',
          href: 'https://www.benzinga.com/go/etoro',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_country: '',
          placement_slug: 'etoro-cta',
          product_id: 24544,
          target_device_type: 'all-devices',
          url: 'https://www.benzinga.com/go/etoro',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto US | CTA` ::Partner:: `eToro` ::Title:: `Limited Time Offer: Trade $100, Get $10`',
        },
        '81484': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Every new account on eToro is credited with $100,000 in a virtual portfolio, so you can practice trading risk-free. Join eToro and discover how simple and intuitive it is to trade, talk and own crypto. Access over 40 cryptocurrencies and crypto2crypto pairs.',
          cta_text: 'Get Started',
          cta_title: 'Get $100,000 to practice your trading skills',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure:
            'eToro USA LLC; Investments are subject to market risk, including the possible loss of principal.',
          href: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          image_url:
            'https://cdnwp-s3.benzinga.com/wp-content/uploads/2018/09/11201141/eToro_logo_small-e1599015523638.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'eToro',
          placement_slug: 'etoro-crypto-non-us',
          product_id: null,
          url: 'https://www.benzinga.com/go/etoro-crypto-non-us',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `eToro Crypto Non-US` ::Partner:: `eToro` ::Title:: `Get $100,000 to practice your trading skills`',
        },
        '81730': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            '70+ cryptos and altcoins, precious metals and national currencies to buy and sell, it’s never been easier to start trading. \r\n',
          cta_text: 'get started',
          cta_title: 'Buy, Hold and Sell Over 70 Cryptos! ',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/09/01135644/uphold.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'Uphold',
          placement_slug: 'uphold-crypto-convertor',
          product_id: 81729,
          url: 'https://www.benzinga.com/go/uphold-crypto-convertor',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Uphold Crypto` ::Partner:: `Uphold` ::Title:: `Buy, Hold and Sell Over 70 Cryptos!`',
        },
        '90817': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'Trust America’s #1 Bitcoin IRA and invest in your future with revolutionary digital assets. Open an account and self-trade 24/7. It takes 3 minutes to create.',
          cta_text: 'Open Account',
          cta_title: 'Invest in cryptocurrency with your IRA',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/bitcoinira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/11/05132138/bitcoin-IRA.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'bitcoinIRA',
          placement_slug: 'bitcoinira-retire',
          product_id: null,
          url: 'https://www.benzinga.com/go/bitcoinira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `bitcoinIRA - Retire` ::Partner:: `bitcoinIRA` ::Title:: `Invest in cryptocurrency with your IRA`',
        },
        '93649': {
          cta_btn_position: 'below_image',
          cta_btn_type: 'button',
          cta_description:
            'iTrustCapital helps investors access crypto within their IRA/401k. Request their Free Crypto IRA Guide now.\r\n',
          cta_text: 'Get Started',
          cta_title: 'Cryptocurrency IRA through iTrust',
          customize_floating_popup: false,
          customize_modal_popup: false,
          disclosure: '',
          href: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          image_url: 'https://cdnwp-s3.benzinga.com/wp-content/uploads/2020/12/16144451/itrust.png',
          impression_tag: '',
          link_type: 'internal',
          partner: 'iTrustCapital',
          placement_slug: 'itrust-crypto-ira',
          product_id: 77915,
          url: 'https://www.benzinga.com/go/itrust-best-crypto-ira',
          utm_action:
            '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `iTrust Crypto IRA` ::Partner:: `iTrustCapital` ::Title:: `Cryptocurrency IRA through iTrust`',
        },
      },
      has_targeting: true,
      placeholder_type: 'secondary',
      placements: [
        {
          campaign: {
            cta_btn_position: 'below_image',
            cta_btn_type: 'button',
            cta_description:
              'Earn crypto on your holdings with a tap of a button. Staking crypto has never been so easy. ',
            cta_text: 'Get Started',
            cta_title: 'Earn Crypto Rewards',
            customize_floating_popup: false,
            customize_modal_popup: false,
            disclosure: '',
            href: 'https://www.benzinga.com/go/exodus-wallet',
            image_url:
              'https://cdnwp-s3.benzinga.com/wp-content/uploads/2021/10/21144956/1-18526_exodus-wallet-bitcoin-exodus-wallet-logo-hd-png.png',
            impression_tag: '',
            link_type: 'internal',
            partner: 'Exodus Wallet',
            placement_slug: 'exodus',
            product_id: null,
            url: 'https://www.benzinga.com/go/exodus-wallet',
            utm_action:
              '::AdvancedCampaign:: `Crypto Advanced Campaign` ::Campaign:: `Exodus` ::Partner:: `Exodus Wallet` ::Title:: `Earn Crypto Rewards`',
          },
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 170985,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 90817,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 81484,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'NON-US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'CA',
          id: 151842,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'COINSMART',
          id: 170835,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 146667,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 68921,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 81730,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 168774,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 145338,
          multiplier: '1',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 172279,
          multiplier: '3',
          type: 'campaign',
        },
        {
          devices: 'all-devices',
          geo_target: 'US',
          id: 93649,
          multiplier: '1',
          type: 'campaign',
        },
      ],
    },
  },
  canonical_link: 'https://www.benzinga.com/money/how-to-buy-nba-top-shots-nft',
  content_footer: {
    blocks: [
      {
        attrs: {
          data: {
            _description: 'field_description',
            _form_id: 'field_form_id',
            _style: 'field_style',
            _title: 'field_title',
            _utm_label: 'field_utm_label',
            description:
              '<ul>\r\n \t<li>Exclusive Crypto Airdrops</li>\r\n \t<li>Altcoin of the Week</li>\r\n \t<li>Insider Interviews</li>\r\n \t<li>News &amp; Show Highlights</li>\r\n \t<li>Completely FREE</li>\r\n</ul>',
            form_id: '6d120c76-8a53-4729-9627-e36a737e2a30',
            style: 'default',
            title: 'The Crypto Rocketship: Weekly Newsletter',
            utm_label: 'Sign Up',
          },
          id: 'block_5fea016510bf8',
          mode: 'edit',
          name: 'acf/newsletter-subscription-box',
        },
        blockName: 'acf/newsletter-subscription-box',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
      },
    ],
    id: 94072,
    title: 'Cryptocurrency Article Footer',
    type: 'footer',
  },
  content_header: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/html',
        innerBlocks: [],
        innerContent: [
          '\n<script src="https://crypto.com/price/static/widget/index.js" id="crypto-widget-script" defer></script>\n<div id="crypto-widget-CoinMarquee" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern" style="height: 190px;"></div>\n\n<style>.header-wrapper{width: 100%;}</style>\n<script>\nif(window.location.href.match(/utm_source=robinhood.com/)) {\n  document.getElementById(\'crypto-widget-script\').remove()\n  document.getElementById(\'crypto-widget-CoinMarquee\').remove()\n  r(() => {\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n  })\n}\n</script>\n',
        ],
        innerHTML:
          '\n<script src="https://crypto.com/price/static/widget/index.js" id="crypto-widget-script" defer></script>\n<div id="crypto-widget-CoinMarquee" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern" style="height: 190px;"></div>\n\n<style>.header-wrapper{width: 100%;}</style>\n<script>\nif(window.location.href.match(/utm_source=robinhood.com/)) {\n  document.getElementById(\'crypto-widget-script\').remove()\n  document.getElementById(\'crypto-widget-CoinMarquee\').remove()\n  r(() => {\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n    document.getElementById(\'crypto-widget-CoinList\').remove()\n  })\n}\n</script>\n',
      },
    ],
    id: 145180,
    title: 'Crypto.com Coin Marquee Header',
    type: 'header',
  },
  cornerstone: {
    child_posts: [],
    current_post_id: 103515,
    current_post_title: 'How to Buy NBA Top Shots NFT',
    id: 134276,
    link: '/money/best-nft-investments/',
    parent_id: 101349,
    parent_link: '/money/what-is-a-non-fungible-token-nft/',
    parent_title: 'NFTs',
    title: 'Best NFTs',
  },
  footer: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/heading',
        innerBlocks: [],
        innerContent: ['\n<h2>Methodology</h2>\n'],
        innerHTML: '\n<h2>Methodology</h2>\n',
      },
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p>Benzinga crafted a specific methodology to rank cryptocurrency exchanges and tools. We prioritized platforms based on offerings, pricing and promotions, customer service, mobile app, user experience and benefits, and security.  To see a comprehensive breakdown of our methodology, please visit see our <a href="https://www.benzinga.com/money/investing/benzingas-crypto-methodology/">Cryptocurrency Methodology</a> page.</p>\n',
        ],
        innerHTML:
          '\n<p>Benzinga crafted a specific methodology to rank cryptocurrency exchanges and tools. We prioritized platforms based on offerings, pricing and promotions, customer service, mobile app, user experience and benefits, and security.  To see a comprehensive breakdown of our methodology, please visit see our <a href="https://www.benzinga.com/money/investing/benzingas-crypto-methodology/">Cryptocurrency Methodology</a> page.</p>\n',
      },
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p><em><strong>Disclaimer:</strong> As per the European Securities and Markets Authority (ESMA), the percentage of retail clients losing money on CFD trading must be updated every three months. Please note that eToro’s new results are 67% in regards to retail investor accounts losing money when trading CFDs with eToro. Due to this change, we require you to immediately update all of your eToro related promotions, web properties, and campaigns featuring CFD disclaimers to 67%.</em></p>\n',
        ],
        innerHTML:
          '\n<p><em><strong>Disclaimer:</strong> As per the European Securities and Markets Authority (ESMA), the percentage of retail clients losing money on CFD trading must be updated every three months. Please note that eToro’s new results are 67% in regards to retail investor accounts losing money when trading CFDs with eToro. Due to this change, we require you to immediately update all of your eToro related promotions, web properties, and campaigns featuring CFD disclaimers to 67%.</em></p>\n',
      },
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p><strong><em>This content should not be interpreted as investment advice. Cryptocurrency is a volatile market, do your independent research and only invest what you can afford to lose.</em></strong></p>\n',
        ],
        innerHTML:
          '\n<p><strong><em>This content should not be interpreted as investment advice. Cryptocurrency is a volatile market, do your independent research and only invest what you can afford to lose.</em></strong></p>\n',
      },
    ],
    id: 68346,
    title: 'Cryptocurrency Footer',
    type: 'footer',
  },
  global_footer: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/paragraph',
        innerBlocks: [],
        innerContent: [
          '\n<p><strong>Want to advertise with us? <a href="https://advertise.benzinga.com/" target="_blank" rel="noreferrer noopener">Send us a message</a>. </strong></p>\n',
        ],
        innerHTML:
          '\n<p><strong>Want to advertise with us? <a href="https://advertise.benzinga.com/" target="_blank" rel="noreferrer noopener">Send us a message</a>. </strong></p>\n',
      },
    ],
    id: 160497,
    title: 'Advertise With Us',
    type: 'footer',
  },
  id: 103515,
  image:
    'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/03/18161911/basketball-1544370_1920-768x683.jpg',
  meta: {
    author: 'Ryan McNamara',
    description: '',
    image:
      'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/03/18161911/basketball-1544370_1920-768x683.jpg',
    modifiedDate: '2021-08-12T12:11:43.000000Z',
    postId: 103515,
    publishedDate: '2021-05-14T16:35:00.000000Z',
    title: 'How to Buy NBA Top Shots NFT',
  },
  parent: {
    child_posts: [
      {
        id: 148060,
        link: '/money/nft-release-calendar/',
        title: 'NFT Release Calendar',
      },
      {
        id: 104732,
        link: '/money/how-to-buy-cryptopunks-nft/',
        title: 'CryptoPunks NFT',
      },
      {
        id: 104460,
        link: '/money/how-to-buy-music-nfts/',
        title: 'Music NFT',
      },
      {
        id: 103515,
        link: '/money/how-to-buy-nba-top-shots-nft/',
        title: 'NBA Top Shot NFT',
      },
      {
        id: 102824,
        link: '/money/how-to-buy-nfts/',
        title: 'How to buy NFTs',
      },
      {
        id: 150464,
        link: '/money/are-nfts-a-good-investment/',
        title: 'Are NFTS a Good Investment?',
      },
      {
        id: 105474,
        link: '/money/are-nfts-a-scam-or-a-digital-bubble/',
        title: 'Are NFTs a Scam?',
      },
      {
        id: 110150,
        link: '/money/best-nft-related-stocks/',
        title: 'NFT RELATED STOCKS',
      },
    ],
    current_post_id: 134276,
    current_post_title: 'Best NFT Projects in 2022',
    id: 134276,
    link: '/money/best-nft-investments/',
    parent_id: 101349,
    parent_link: '/money/what-is-a-non-fungible-token-nft/',
    parent_title: 'NFTs',
    title: 'Best NFTs',
  },
  sidebar: {
    blocks: [
      {
        attrs: {
          height: 649,
          id: 165344,
          linkDestination: 'custom',
          sizeSlug: 'large',
          width: 325,
        },
        blockName: 'core/image',
        href: 'https://www.benzinga.com/go/celsius-sidebar',
        image: {
          attachment_id: 165344,
          caption: '',
          image_id: 165344,
          sizes: {
            'Multi Rating Pro Thumbnail': {
              height: 100,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-100x100.png',
              width: 100,
            },
            large: {
              height: 1024,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-512x1024.png',
              width: 512,
            },
            medium: {
              height: 300,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-150x300.png',
              width: 150,
            },
            'slideshow-img': {
              height: 600,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-600x600.png',
              width: 600,
            },
            thumbnail: {
              height: 150,
              url: 'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2022/01/06150824/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-150x150.png',
              width: 150,
            },
          },
          title: 'CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1',
        },
        innerBlocks: [],
        innerContent: [
          '\n<figure class="wp-block-image size-large is-resized"><a href="https://www.benzinga.com/go/celsius-sidebar"><img src="https://www.benzinga.com/wp-content/uploads/2022/01/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-512x1024.png" alt="" class="wp-image-165344" width="325" height="649"/></a></figure>\n',
        ],
        innerHTML:
          '\n<figure class="wp-block-image size-large is-resized"><a href="https://www.benzinga.com/go/celsius-sidebar"><img src="https://www.benzinga.com/wp-content/uploads/2022/01/CEL-BenzingaDisplay-Ad-DEC21-300x600@2X-1-512x1024.png" alt="" class="wp-image-165344" width="325" height="649"/></a></figure>\n',
      },
      {
        attrs: {
          align: '',
          data: {
            _related_post_style: 'field_related_post_style',
            _related_posts: 'field_5c7e673bead4b',
            _title: 'field_5c7e67175e8bb',
            related_post_style: 'default',
            related_posts: ['96298', '95574', '101349', '105115'],
            title: 'Learn About Cryptocurrency',
          },
          id: 'l3WydAMdT2',
          mode: 'edit',
          name: 'acf/sidebar-related-posts',
        },
        blockName: 'acf/sidebar-related-posts',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
        posts: [
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/6c99a46a209a29b1e26dc24dcb543899?d=mm',
              name: 'Logan Ross',
            },
            date: 'February 16th, 2022',
            description:
              "What is Bitcoin? Does it have a chance at becoming the global reserve currency? Start with Benzinga's guide to learn more today.",
            id: 96298,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/01/15143715/the-company-3338207_1920-768x480.jpg',
            published_at: '2022-02-16T00:37:00.000000Z',
            seotitle: 'What is Bitcoin? • Beginners Guide',
            slug: 'what-is-bitcoin',
            title: 'What is Bitcoin?',
            url: '/money/what-is-bitcoin/',
          },
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/6c99a46a209a29b1e26dc24dcb543899?d=mm',
              name: 'Logan Ross',
            },
            date: 'February 16th, 2022',
            description:
              'Ethereum is a decentralized global computing platform with its own programming language, Solidity, and cryptocurrency, Ether.',
            id: 95574,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/01/12102515/0bo235rhqec-768x512.jpg',
            published_at: '2022-02-16T10:28:00.000000Z',
            seotitle: 'What is Ethereum? • DeFi, Smart Contracts & Eth2',
            slug: 'what-is-ethereum',
            title: 'What is Ethereum?',
            url: '/money/what-is-ethereum/',
          },
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/a601583e19db33fdae89f59b38b6d4cc?d=mm',
              name: 'Chris Katje',
            },
            date: 'January 20th, 2022',
            description:
              'A non-fungible token (NFT) is a digital asset that is unique and indivisible. Learn more about what NFTs are today.',
            id: 101349,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/08/20093407/Screen-Shot-2021-08-20-at-9.34.01-AM.png',
            published_at: '2022-01-20T20:13:00.000000Z',
            seotitle: 'What Are NFTs? • Top Colletions Crypto',
            slug: 'what-is-a-non-fungible-token-nft',
            title: 'What Are NFTs?',
            url: '/money/what-is-a-non-fungible-token-nft/',
          },
          {
            author: {
              gravatar: '//secure.gravatar.com/avatar/8acd10f73d8a83ef13da39a2cbe047da?d=mm',
              name: 'Ryan McNamara',
            },
            date: 'March 29th, 2021',
            description:
              'Earning interest on your Ethereum is a great way to grow your cryptocurrency holdings. Find out how to earn interest on your Ethereum in 4 easy steps.',
            id: 105115,
            image:
              'https://s3.amazonaws.com/wp-uploads.benzinga-money.prod/wp-content/uploads/2021/03/29142306/0bo235rhqec-1-768x512.jpg',
            published_at: '2021-03-29T14:36:35.000000Z',
            seotitle: '',
            slug: 'how-to-earn-interest-on-ethereum',
            title: 'How to Earn Interest on Ethereum',
            url: '/money/how-to-earn-interest-on-ethereum/',
          },
        ],
      },
      {
        attrs: {
          data: {
            _description_visible: 'field_description_visible',
            _header_see_more_link: 'field_header_see_more_link',
            _header_see_more_text: 'field_header_see_more_text',
            _news_exclude_authors: 'field_news_exclude_authors',
            _news_feed_mode: 'field_news_feed_mode',
            _news_feed_parsely_author: 'field_news_feed_parsely_author',
            _news_feed_parsely_category: 'field_news_feed_parsely_category',
            _news_feed_parsely_content: 'field_news_feed_parsely_content',
            _news_feed_parsely_days: 'field_news_feed_parsely_days',
            _news_feed_parsely_limit: 'field_news_feed_parsely_limit',
            _news_feed_parsely_section: 'field_news_feed_parsely_section',
            _news_feed_parsely_tag: 'field_news_feed_parsely_tag',
            _news_feed_primary_header: 'field_news_feed_primary_header',
            _news_feed_style: 'field_news_feed_style',
            _news_feed_type: 'field_news_feed_type',
            _show_newsletter_block: 'field_show_newsletter_block',
            _thumbnail_hidden: 'field_thumbnail_hidden',
            _title: 'field_title',
            description_visible: '1',
            header_see_more_link: '',
            header_see_more_text: '',
            news_exclude_authors: '',
            news_feed_mode: 'default',
            news_feed_parsely_author: '',
            news_feed_parsely_category: 'Cryptocurrency',
            news_feed_parsely_content: 'top-posts',
            news_feed_parsely_days: '1',
            news_feed_parsely_limit: '5',
            news_feed_parsely_section: '',
            news_feed_parsely_tag: '',
            news_feed_primary_header: '0',
            news_feed_style: 'rated',
            news_feed_type: 'parsely',
            show_newsletter_block: '0',
            thumbnail_hidden: '0',
            title: 'Top Cryptocurrency News',
          },
          id: 'block_60612cba1562e',
          mode: 'edit',
          name: 'acf/news-feed',
        },
        blockName: 'acf/news-feed',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
        top_posts: [
          {
            author: 'Samyuktha Sriram',
            authors: ['Samyuktha Sriram'],
            image_url:
              'https://cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/k_7.jpeg?width=720',
            link: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26053893/bye-bye-bitcoin-rich-dad-poor-dad-author-sees-us-seizing-all-crypto-after-bidens-executive?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-09T03:12:34',
            section: 'Cryptocurrency',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Cryptocurrency',
              'category: General',
              'category: Government',
              'category: Markets',
              'category: News',
              'category: Politics',
              'category: Regulations',
              'pageType: NewsArticle',
              'parsely_smart:entity:Bitcoin',
              'parsely_smart:entity:Cryptocurrency',
              'parsely_smart:entity:Ethereum',
              'parsely_smart:entity:Hedge (finance)',
              'parsely_smart:entity:Rich Dad Poor Dad',
              'parsely_smart:entity:Robert Kiyosaki',
              'parsely_smart:iab:Law, Gov’t & Politics',
              'parsely_smart:iab:Legal Issues',
              'parsely_smart:iab:Technology',
              'symbol: $BTC',
              'symbol: $ETH',
              'tag: Bitcoin',
              'tag: Ethereum',
              'tag: Joe Biden',
              'tag: Robert Kiyosaki',
            ],
            thumb_url_medium:
              'https://images.parsely.com/p4GNRlE6KuEW700zfI_dh612TkM=/85x85/smart/https%3A//cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/k_7.jpeg%3Fwidth%3D720',
            title:
              "Bye-Bye Bitcoin? 'Rich Dad Poor Dad' Author Sees US Seizing All Crypto After Biden's Executive Order | Benzinga",
            url: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26053893/bye-bye-bitcoin-rich-dad-poor-dad-author-sees-us-seizing-all-crypto-after-bidens-executive?itm_source=parsely-api',
          },
          {
            author: 'Nina Zdinjak',
            authors: ['Nina Zdinjak'],
            image_url:
              'https://cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/15_15.png?width=720',
            link: 'https://www.benzinga.com/markets/cannabis/22/03/26096494/this-cannabis-stock-has-outperformed-apple-netflix-facebook-and-amazon?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-11T14:08:40',
            section: 'Cannabis',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Cannabis',
              'category: Markets',
              'category: News',
              'category: Small Cap',
              'pageType: NewsArticle',
              'parsely_smart:entity:Agriculture',
              'parsely_smart:entity:Amazon (company)',
              'parsely_smart:entity:Apple Inc.',
              'parsely_smart:entity:E-commerce',
              'parsely_smart:entity:Meta Platforms',
              'parsely_smart:entity:Netflix',
              'parsely_smart:iab:Agriculture',
              'parsely_smart:iab:Business',
              'symbol: AAPL',
              'symbol: AMZN',
              'symbol: FB',
              'symbol: GRWG',
              'symbol: NFLX',
              'tag: cannabis stocks',
              'tag: weed stocks performance',
            ],
            thumb_url_medium:
              'https://images.parsely.com/vf9kpTkTuTY3Ao9QuQ7VXKeNkbg=/85x85/smart/https%3A//cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/15_15.png%3Fwidth%3D720',
            title: 'This Cannabis Stock Has Outperformed Apple, Netflix, Facebook And Amazon | Benzinga',
            url: 'https://www.benzinga.com/markets/cannabis/22/03/26096494/this-cannabis-stock-has-outperformed-apple-netflix-facebook-and-amazon?itm_source=parsely-api',
          },
          {
            author: 'Chris Katje',
            authors: ['Chris Katje'],
            image_url:
              'https://cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/1600px-mtg_first_day.jpg',
            link: 'https://www.benzinga.com/news/22/03/26063227/members-of-congress-buy-energy-defense-stocks-prior-to-russian-invasion-of-ukraine-who-they-are-what?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-09T16:04:58',
            section: 'News',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: General',
              'category: News',
              'category: Politics',
              'pageType: NewsArticle',
              'parsely_smart:entity:Chevron Corporation',
              'parsely_smart:entity:Lockheed Martin',
              'parsely_smart:entity:Marjorie Taylor Greene',
              'parsely_smart:iab:Business',
              'parsely_smart:iab:Government',
              'parsely_smart:iab:Law, Gov’t & Politics',
              'symbol: CVX',
              'symbol: ENLC',
              'symbol: ET',
              'symbol: LMT',
              'symbol: NEE',
              'symbol: PAA',
              'symbol: PPL',
              'symbol: PSX',
              'symbol: SPY',
              'symbol: XLE',
              'tag: Alexandria Ocasio-Cortez',
              'tag: Congress',
              'tag: Congress trading',
              'tag: Ilhan Omar',
              'tag: Marjorie Taylor Greene',
              'tag: Mark Green',
              'tag: Robert Wittman',
              'tag: Russia',
              'tag: Russia-Ukraine Conflict',
              'tag: Ukraine',
              'tag: Unusual Whales',
              'tag: UnusualWhales',
              'tag: Virginia Foxx',
              'tag: defense stocks',
              'tag: energy stocks',
              'tag: oil stocks',
            ],
            thumb_url_medium:
              'https://images.parsely.com/RB9ZMnlw1jXRD8dJXvhBxLtZfL4=/85x85/smart/https%3A//cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/1600px-mtg_first_day.jpg',
            title:
              'SPDR S&P 500 ETF (ETF:SPY), Chevron Corporation (NYSE:CVX) - Members Of Congress Buy Energy, Defense ...',
            url: 'https://www.benzinga.com/news/22/03/26063227/members-of-congress-buy-energy-defense-stocks-prior-to-russian-invasion-of-ukraine-who-they-are-what?itm_source=parsely-api',
          },
          {
            author: 'Rachit Vats',
            authors: ['Rachit Vats'],
            image_url:
              'https://cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/es8_es6_ec6.jpg',
            link: 'https://www.benzinga.com/news/22/03/26094770/why-rumors-of-nio-partnering-with-warren-buffett-backed-byd-are-resurfacing?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-11T04:57:52',
            section: 'News',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Media',
              'category: News',
              'category: Rumors',
              'category: Tech',
              'pageType: NewsArticle',
              'parsely_smart:entity:Automotive industry in China',
              'parsely_smart:entity:BYD Auto',
              'parsely_smart:entity:JAC Motors',
              'parsely_smart:entity:NIO (car company)',
              'parsely_smart:entity:Tesla, Inc.',
              'parsely_smart:entity:XPeng',
              'parsely_smart:iab:Automotive',
              'parsely_smart:iab:Technology',
              'symbol: BYDDY',
              'symbol: NIO',
              'symbol: TSLA',
              'symbol: XPEV',
              'tag: NIO House',
              'tag: Wang Chuanfu',
              'tag: Warren Buffett',
              'tag: William Li',
            ],
            thumb_url_medium:
              'https://images.parsely.com/axMFB-R1usETnaDgviaxTJgShNg=/85x85/smart/https%3A//cdn.benzinga.com/files/imagecache/bz2_opengraph_meta_image_400x300/images/story/2012/es8_es6_ec6.jpg',
            title: 'NIO Inc. (NYSE:NIO), BYD COMPANY LTD ADR (BYDDY) - Why Rumors Of Nio Partnering With Warren ...',
            url: 'https://www.benzinga.com/news/22/03/26094770/why-rumors-of-nio-partnering-with-warren-buffett-backed-byd-are-resurfacing?itm_source=parsely-api',
          },
          {
            author: 'Shivdeep Dhaliwal',
            authors: ['Shivdeep Dhaliwal'],
            image_url:
              'https://cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/executium-8xo9gqaamzc-unsplash_1_10.jpg?width=720',
            link: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26096425/dogecoin-shows-signs-of-coming-back-alive-could-the-love-from-amc-be-a-game-changer?itm_source=parsely-api',
            metadata: '',
            pub_date: '2022-03-11T10:10:39',
            section: 'Cryptocurrency',
            tags: [
              'PageIsBzPro: BZ+PRO',
              'category: Cryptocurrency',
              'category: Markets',
              'category: Movers',
              'category: News',
              'category: Trading Ideas',
              'pageType: NewsArticle',
              'parsely_smart:entity:Bitcoin',
              'parsely_smart:entity:Cryptocurrency',
              'parsely_smart:entity:Dogecoin',
              'parsely_smart:iab:Business',
              'parsely_smart:iab:Law, Gov’t & Politics',
              'parsely_smart:iab:Technology',
              'symbol: $DOGE',
              'symbol: AMC',
              'tag: Meme Coins',
              'tag: dogecoin',
            ],
            thumb_url_medium:
              'https://images.parsely.com/_F5Qnj1_u9OlcT_uRw0Gcp33Di4=/85x85/smart/https%3A//cdn2.benzinga.com/files/imagecache/og_image_social_share_1200x630/images/story/2012/executium-8xo9gqaamzc-unsplash_1_10.jpg%3Fwidth%3D720',
            title: 'Dogecoin Shows Signs Of Coming Back Alive: Could The Love From AMC Be A Game Changer? | Benzinga',
            url: 'https://www.benzinga.com/markets/cryptocurrency/22/03/26096425/dogecoin-shows-signs-of-coming-back-alive-could-the-love-from-amc-be-a-game-changer?itm_source=parsely-api',
          },
        ],
      },
      {
        attrs: {
          align: '',
          data: {
            _default_widget: 'default_widget',
            default_widget: 94647,
          },
          id: 'block_5e6015e022762',
          mode: 'edit',
          name: 'acf/page-sidebar-placement',
        },
        blockName: 'acf/page-sidebar-placement',
        innerBlocks: [],
        innerContent: [],
        innerHTML: '',
      },
      {
        attrs: [],
        blockName: 'core/html',
        innerBlocks: [],
        innerContent: [
          '\n<div id="crypto-widget-CoinList" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern"></div>\n',
        ],
        innerHTML:
          '\n<div id="crypto-widget-CoinList" data-coins="bitcoin,ethereum,cardano,shiba-inu,dogecoin,crypto-com-coin,solana,xrp,polkadot-new,vechain" data-design="modern"></div>\n',
      },
    ],
    id: 59458,
    slug: 'cryptocurrency-sidebar',
    title: 'Cryptocurrency /Money Sidebar',
    type: 'sidebar',
  },
  sidebar_placement: {
    blocks: [
      {
        attrs: [],
        blockName: 'core/html',
        innerBlocks: [],
        innerContent: [
          '\n<div style="width:300px"><a class="twitter-timeline" href="https://twitter.com/ALPublicHealth?ref_src=twsrc%5Etfw">Tweets by ALPublicHealth</a> </div>\n<script async="" src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\n',
        ],
        innerHTML:
          '\n<div style="width:300px"><a class="twitter-timeline" href="https://twitter.com/ALPublicHealth?ref_src=twsrc%5Etfw">Tweets by ALPublicHealth</a> </div>\n<script async="" src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>\n',
      },
    ],
    id: 66025,
    title: 'ALPublicHealth Twitter Timeline',
    type: 'widget',
  },
  slug: 'how-to-buy-nba-top-shots-nft',
  title: 'How to Buy NBA Top Shots NFT',
};
